import React from 'react'
import ProductoItem from '../components/prodmod'

const ProductoOpcion = (props) => {      
      if(!props.opcion){  
        return "CARGANDO"
      }

      function ponesaca(item, cantidad){
        props.opcionAct(item, cantidad)
      }

      function cambiaGaleria(galeria){
        props.imgAct(galeria)
      }

      const  listaItems = props.opcion.items.map((item,i)=>{
        return <ProductoItem key={i} item={item}  itemAct = {ponesaca} imgAct = { cambiaGaleria }  prodUnidad = {props.prodUnidad} />
      })

		  return (
		  	<section>
          <h5 className="mt-3 mb-3 text-info">{props.opcion.nombre}</h5>
          <section className="row">
           { props.opcion.items != null  &&
                listaItems 
          }
          </section>
        </section>
		  )
}
export default ProductoOpcion




// WEBPACK FOOTER //
// ./src/components/producto_opcion_mod.js